import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Button, Alert } from 'react-bootstrap';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';

const Surpresinha = () => {
  const [matriz, setMatriz] = useState('7-8');
  const [quantidadeJogos, setQuantidadeJogos] = useState(1);
  const [jogos, setJogos] = useState([]);
  const [jogosGerados, setJogosGerados] = useState(false);
  const { userData } = useUser();
  const navigate = useNavigate();

  const pares = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  const impares = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25];

  // Verificar se usuário é premium
  useEffect(() => {
    if (userData?.plan !== 'premium' && userData?.plan !== 'prem') {
      // Redirecionar para página de upgrade ou home se não for premium
      navigate('/upgrade');
    }
  }, [userData, navigate]);

  const handleMatrizChange = (event) => {
    setMatriz(event.target.value);
  };

  const handleQuantidadeJogosChange = (event) => {
    const value = parseInt(event.target.value);
    setQuantidadeJogos(value);
  };

  const shuffle = (array) => {
    const newArray = array.slice();
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  const gerarJogos = () => {
    // Verificar novamente se é premium
    if (userData?.plan !== 'premium' && userData?.plan !== 'prem') {
      alert('Esta funcionalidade é exclusiva para usuários Premium');
      navigate('/upgrade');
      return;
    }

    const novosJogos = [];
    
    for (let i = 0; i < quantidadeJogos; i++) {
      let jogo = [];
      if (matriz === '7-8') {
        jogo = [
          ...shuffle(pares).slice(0, 7),
          ...shuffle(impares).slice(0, 8)
        ];
      } else if (matriz === '8-7') {
        jogo = [
          ...shuffle(pares).slice(0, 8),
          ...shuffle(impares).slice(0, 7)
        ];
      } else if (matriz === '6-9') {
        jogo = [
          ...shuffle(pares).slice(0, 6),
          ...shuffle(impares).slice(0, 9)
        ];
      } else if (matriz === '9-6') {
        jogo = [
          ...shuffle(pares).slice(0, 9),
          ...shuffle(impares).slice(0, 6)
        ];
      } else if (matriz === '5-10') {
        jogo = [
          ...shuffle(pares).slice(0, 5),
          ...shuffle(impares).slice(0, 10)
        ];
      } else if (matriz === '10-5') {
        jogo = [
          ...shuffle(pares).slice(0, 10),
          ...shuffle(impares).slice(0, 5)
        ];
      }
      novosJogos.push(jogo.sort((a, b) => a - b).join(', '));
    }

    setJogos(novosJogos);
    setJogosGerados(true);
  };

  const salvarJogos = () => {
    const fileName = `surpresinha-${matriz}.ltc`;
    const fileContent = btoa(jogos.join('\n'));
    const element = document.createElement("a");
    const file = new Blob([fileContent], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
  };

  const exportarJogosParaTxt = () => {
    const element = document.createElement("a");
    const formattedJogos = jogos.map(jogo => 
      jogo.split(', ').map(numero => 
        parseInt(numero, 10) < 10 ? `0${numero}` : numero
      ).join(' ')
    );
    const file = new Blob(formattedJogos.map(jogo => `${jogo}\n`), { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = "jogos.txt";
    document.body.appendChild(element);
    element.click();
  };

  // Se não for premium, não renderiza o componente
  if (userData?.plan !== 'premium' && userData?.plan !== 'prem') {
    return (
      <div className="container">
        <Alert variant="warning">
          <h4>Acesso Restrito</h4>
          <p>O Surpresinha é uma funcionalidade exclusiva para usuários Premium.</p>
          <Button variant="primary" onClick={() => navigate('/upgrade')}>
            Fazer Upgrade para Premium
          </Button>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>Surpresinha Premium</h1>
      
      <div className="alert alert-success">
        <strong>Plano Premium Ativo</strong> - Gere quantos jogos quiser!
      </div>
      
      <div className="form-group">
        <label htmlFor="matriz">Escolha a Matriz Par-Ímpar</label>
        <select id="matriz" className="form-control" value={matriz} onChange={handleMatrizChange}>
          <option value="7-8">7-8</option>
          <option value="8-7">8-7</option>
          <option value="6-9">6-9</option>
          <option value="9-6">9-6</option>
          <option value="5-10">5-10</option>
          <option value="10-5">10-5</option>
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="quantidadeJogos">Quantidade de Jogos</label>
        <input
          type="number"
          id="quantidadeJogos"
          className="form-control"
          min="1"
          max="1000"
          value={quantidadeJogos}
          onChange={handleQuantidadeJogosChange}
        />
        <small className="form-text text-muted">
          Gere até 1000 jogos por vez (apenas para Premium)
        </small>
      </div>
      <Button variant="outline-primary" onClick={gerarJogos}>Gerar Jogos</Button>

      {jogosGerados && (
        <>
          <Button variant="outline-secondary" className="ml-2" onClick={salvarJogos}>Salvar</Button>
          <Button variant="outline-secondary" className="ml-2" onClick={exportarJogosParaTxt}>Exportar para .txt</Button>
        </>
      )}

      {jogos.length > 0 && (
        <div>
          <h2 className="mt-4">Jogos Gerados:</h2>
          <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Jogo</th>
                </tr>
              </thead>
              <tbody>
                {jogos.map((jogo, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{jogo}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Surpresinha;